import React from 'react';
import styled from 'styled-components';
import { smallerThanOrEqualTo } from '../../../core/util/styledComponents';
import { colors } from '../../../constants/colors';

const Close = styled.div.withConfig({ componentId: 'sc-6l0hed-0' })`
  width: 25px;
  height: 25px;
  position: absolute;
  right: 18px;
  top: 21px;
  cursor: pointer;
  margin: 0 0 -10px auto;
  ${smallerThanOrEqualTo.md`
    margin: 0 0 0 auto;
  `}

  &:before {
    content: '';
    left: 50%;
    height: 100%;
    width: 1px;
    position: absolute;
    transform: rotate(45deg);
    background-color: ${colors.squid};
  }

  &:after {
    content: '';
    left: 50%;
    height: 100%;
    width: 1px;
    position: absolute;
    transform: rotate(-45deg);
    background-color: ${colors.squid};
  }
`;

type Props = {
  onClick: (...args: any[]) => any;
};

const CloseX = ({ onClick }: Props) => <Close onClick={onClick} />;

export default CloseX;
